import { useMemo } from 'react';
import { useGetPackageData } from './useGetPackageData';

/** вычисляет есть ли скидка */
export const useGetDiscount = (): {
  discount: boolean;
} => {
  const { packageData } = useGetPackageData();
  const discount = useMemo(() => {
    if (!packageData?.previous_price) {
      return false;
    }

    return packageData?.previous_price > packageData?.net_price;
  }, [packageData]);

  return {
    discount,
  };
};
